import DefaultIntegrationCard from './DefaultIntegrationCard'
import IntegrationCard from './IntegrationCard'

interface Props {
  isS1NameEnabled: boolean
  onSubmit: (id: string, label: string, onClose: () => void) => void
  isLoading: boolean
  name: string
  logoUrl: string
  id: string
}

const ProviderIntegrationCards = ({
  isS1NameEnabled,
  onSubmit,
  isLoading,
  name,
  logoUrl,
  id,
}: Props) => {
  if (isS1NameEnabled) {
    return (
      <IntegrationCard
        key={id}
        name={name}
        logoUrl={logoUrl}
        onSubmit={(label, onClose) => onSubmit(id, label, onClose)}
        isLoading={isLoading}
      />
    )
  }

  return (
    <DefaultIntegrationCard
      key={id}
      name={name}
      logoUrl={logoUrl}
      onClick={() => onSubmit(id, '', () => {})}
    />
  )
}

export default ProviderIntegrationCards
